/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statement_Taxonomy_Editor_Sign_DebitInputs */

const en_statement_taxonomy_editor_sign_debit = /** @type {(inputs: Statement_Taxonomy_Editor_Sign_DebitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Debit (+1)`)
};

const nl_statement_taxonomy_editor_sign_debit = /** @type {(inputs: Statement_Taxonomy_Editor_Sign_DebitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Debet (+1)`)
};

/**
* | output |
* | --- |
* | "Debit (+1)" |
*
* @param {Statement_Taxonomy_Editor_Sign_DebitInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const statement_taxonomy_editor_sign_debit = /** @type {((inputs?: Statement_Taxonomy_Editor_Sign_DebitInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statement_Taxonomy_Editor_Sign_DebitInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_statement_taxonomy_editor_sign_debit(inputs)
	return en_statement_taxonomy_editor_sign_debit(inputs)
});